import { RegisterBaseModel, REGISTER_BASE_EXCLUDE_PROPERTIES } from '@rift/models/restapi/RegisterBase.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export interface IRegisterAlternativeModel extends IRestModel {
    lines: Array<number>;
}

export class RegisterAlternativeModel extends RegisterBaseModel implements IRegisterAlternativeModel, IRestModel {

    public lines: Array<number> = null;

    public constructor() {
        super();

        this.registerProperty('lines');
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-RegisterAlternativeModel', ['registerType', ...REGISTER_BASE_EXCLUDE_PROPERTIES]);
        super.loadFromRestApiModel(restModel);

        this.lines = restModel.Lines;

        this.setPropertyOriginalValue('lines', this.lines);

        this.setIndexes();
    }

    public toRestApiModel(): any {
        return {
            ...super.toRestApiModel(),
            Lines: this.lines,
        };
    }

    public setIndexes(): void {
        super.setIndexesBase(this.lines, [], []);
    }
}
